export default __webpack_public_path__ + "static/media/1WF.dbae9f35.png";